/* PendingImportsBar — Kullanicinin bekleyen staging batchlerini gosterir.
   Kullanim: Accounting sayfasinin uzerinde SystemHealthBanner ile birlikte mount edilir.
*/
import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FileWarning, ChevronRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;
const hdrs = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const KIND_LABEL = {
    invoices_xlsx: 'Fatura Excel',
    bank_xlsx: 'Banka Excel',
    bank_csv: 'Banka CSV',
};

export default function PendingImportsBar() {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = useCallback(() => {
        axios.get(`${API}/api/accounting/imports/staging`, { headers: hdrs() })
            .then((r) => setItems(r.data.items || []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, []);
    useEffect(() => { load(); }, [load]);

    if (loading || items.length === 0) return (
        loading ? null : (
            <div className="text-right">
                <button
                    onClick={() => navigate('/accounting/imports-history')}
                    className="text-xs text-gray-500 hover:text-gray-900 underline"
                    data-testid="open-import-history">
                    Import Gecmisi (30 gun, geri al)
                </button>
            </div>
        )
    );

    return (
        <div className="bg-violet-50 border border-violet-300 rounded-xl p-3" data-testid="pending-imports-bar">
            <div className="flex items-center gap-2 mb-2">
                <FileWarning size={14} className="text-violet-700" />
                <span className="text-sm font-semibold text-violet-900">
                    {items.length} bekleyen import onayi
                </span>
                <span className="text-[11px] text-violet-700">
                    · Veriler DB'ye yazilmadi, karar bekliyor
                </span>
                <button
                    onClick={() => navigate('/accounting/imports-history')}
                    className="ml-auto text-xs text-violet-700 hover:text-violet-900 underline"
                    data-testid="open-import-history">
                    Import Gecmisi
                </button>
            </div>
            <div className="space-y-1.5">
                {items.map((b) => (
                    <button
                        key={b.id}
                        onClick={() => navigate(`/accounting/imports/${b.id}`)}
                        className="w-full flex items-center gap-3 px-2.5 py-1.5 bg-white hover:bg-violet-100 border border-violet-200 rounded-lg text-left transition-colors"
                        data-testid={`pending-batch-${b.id}`}
                    >
                        <span className="text-xs px-2 py-0.5 bg-violet-100 text-violet-800 rounded font-semibold">
                            {KIND_LABEL[b.kind] || b.kind}
                        </span>
                        <span className="text-sm text-gray-800 truncate flex-1">{b.filename}</span>
                        <span className="text-[11px] text-gray-600">
                            {b.stats?.total || 0} satir
                            {(b.stats?.flagged || 0) + (b.stats?.error || 0) > 0 && (
                                <span className="ml-1 text-amber-700 font-semibold">
                                    · {(b.stats?.flagged || 0) + (b.stats?.error || 0)} suphe
                                </span>
                            )}
                            {(b.stats?.pending || 0) > 0 && (
                                <span className="ml-1 text-rose-700 font-semibold">
                                    · {b.stats.pending} bekleyen
                                </span>
                            )}
                        </span>
                        <ChevronRight size={14} className="text-violet-600" />
                    </button>
                ))}
            </div>
        </div>
    );
}
